import { GlIcon, GlPopover } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import { HEALTH_STATUS_AT_RISK, HEALTH_STATUS_NEEDS_ATTENTION, HEALTH_STATUS_ON_TRACK, healthStatusColorMap, healthStatusIconMap } from 'ee/sidebar/constants';
export default {
    name: 'WorkItemRolledUpHealthStatus',
    components: {
        GlIcon,
        GlPopover
    },
    i18n: {
        healthStatusLabel: s__('WorkItem|Health status'),
        atRiskLabel: s__('WorkItem|at risk'),
        onTrackLabel: s__('WorkItem|on track'),
        attentionLabel: s__('WorkItem|attention')
    },
    props: {
        rolledUpHealthStatus: {
            type: Array,
            required: true
        },
        healthStatusVisible: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        rolledUpOnTrackWorkItems () {
            return this.rolledUpHealthStatus?.find((status)=>status.healthStatus === HEALTH_STATUS_ON_TRACK);
        },
        rolledUpAtRiskWorkItems () {
            return this.rolledUpHealthStatus?.find((status)=>status.healthStatus === HEALTH_STATUS_AT_RISK);
        },
        rolledUpNeedsAttentionWorkItems () {
            return this.rolledUpHealthStatus?.find((status)=>status.healthStatus === HEALTH_STATUS_NEEDS_ATTENTION);
        },
        showRolledUpHealthStatus () {
            return this.rolledUpOnTrackWorkItems?.count || this.rolledUpAtRiskWorkItems?.count || this.rolledUpNeedsAttentionWorkItems?.count;
        }
    },
    methods: {
        getItemLabel (count) {
            return count === 1 ? s__('WorkItem|item') : s__('WorkItem|items');
        },
        getNeedLabel (count) {
            return count === 1 ? s__('WorkItem|needs') : s__('WorkItem|need');
        },
        statusClass (healthStatus) {
            return healthStatusColorMap[healthStatus];
        },
        statusIcon (healthStatus) {
            return healthStatusIconMap[healthStatus];
        }
    },
    HEALTH_STATUS_ON_TRACK,
    HEALTH_STATUS_NEEDS_ATTENTION,
    HEALTH_STATUS_AT_RISK
};
